import {
  adminSystemIndex
} from '@/api/systemManagement/SystemConfig'
import {
  crmSettingConfigData
} from '@/api/systemManagement/SystemCustomer'
import Lockr from 'lockr'

/** 記錄 側邊索引 */
const app = {
  state: {
    logo: '',
    name: '',
    lang: localStorage.lang || 'cn',
    sidebar: {
      activeIndex: '' // 目前啟用的 行
    },
    navbar: {
      activeIndex: '' // 導航目前是第幾個 個人中心需要
    },
    /** CRM配置資訊 */
    CRMConfig: {}
  },

  mutations: {
    SET_ACTIVEINDEX: (state, path) => {
      state.sidebar.activeIndex = path
    },
    SET_NAVACTIVEINDEX: (state, path) => {
      state.navbar.activeIndex = path
    },
    SET_APPLOGO: (state, logo) => {
      state.logo = logo
    },
    SET_APPNAME: (state, name) => {
      state.name = name
    },
    SET_LANG: (state, lang) => {
      state.lang = lang
      window.app.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      window.location.reload()
    },
    SET_CRMCONFIG: (state, config) => {
      state.CRMConfig = config
    }
  },

  actions: {
    // 登錄
    SystemLogoAndName({
      commit
    }) {
      return new Promise((resolve, reject) => {
        adminSystemIndex().then(response => {
          commit('SET_APPNAME', response.data.name)
          commit('SET_APPLOGO', response.data.logo)
          Lockr.set('systemLogo', response.data.logo)
          Lockr.set('systemName', response.data.name)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 獲取客戶管理配置
     */
    CRMSettingConfig({
      commit
    }) {
      return new Promise((resolve, reject) => {
        crmSettingConfigData().then(response => {
          commit('SET_CRMCONFIG', response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default app
